// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fltt-slip {
  --fltt-ink: #0f3d2e;
  --fltt-accent: var(--brand-primary, #0877bc);
  --fltt-accent-2: var(--brand-secondary, #30d5c8);
  --fltt-forest: #1f6b4a;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  border-radius: 20px;
  background:
    radial-gradient(120% 80% at 100% 0%, color-mix(in srgb, var(--fltt-accent-2) 18%, transparent), transparent 55%),
    radial-gradient(90% 70% at 0% 0%, color-mix(in srgb, var(--fltt-accent) 14%, transparent), transparent 50%),
    var(--bg-card, #fff);
  border: 1px solid color-mix(in srgb, var(--fltt-accent) 16%, var(--border-color, rgba(0, 0, 0, 0.08)));
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.fltt-slip::before {
  content: "";
  position: absolute;
  inset: 0 auto auto 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(
    90deg,
    var(--fltt-accent) 0%,
    var(--fltt-accent-2) 55%,
    var(--fltt-forest) 100%
  );
}

.fltt-slip__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.fltt-slip__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.fltt-slip__brand-mark {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(
    145deg,
    var(--fltt-accent) 0%,
    color-mix(in srgb, var(--fltt-accent-2) 70%, var(--fltt-accent)) 100%
  );
  box-shadow: 0 6px 14px color-mix(in srgb, var(--fltt-accent) 28%, transparent);
  flex-shrink: 0;
}

.fltt-slip__brand-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.fltt-slip__kicker {
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-secondary, #6b7280);
}

.fltt-slip__title {
  font-size: 16px;
  font-weight: 780;
  letter-spacing: -0.02em;
  color: var(--text-color, #111);
  line-height: 1.15;
}

.fltt-slip__week {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary, #6b7280);
  text-align: right;
  line-height: 1.3;
  max-width: 42%;
}

.fltt-slip__highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
}

.fltt-slip__chip {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid transparent;
}

.fltt-slip__chip-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary, #6b7280);
}

.fltt-slip__chip-prev {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary, #6b7280);
}

.fltt-slip__chip strong {
  font-variant-numeric: tabular-nums;
  font-size: 16px;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.fltt-slip__chip--up {
  background: color-mix(in srgb, var(--brand-success, #32d74b) 12%, transparent);
  border-color: color-mix(in srgb, var(--brand-success, #32d74b) 28%, transparent);
  color: #0f7a32;
}

.fltt-slip__chip--down {
  background: color-mix(in srgb, var(--brand-danger, #ff453a) 12%, transparent);
  border-color: color-mix(in srgb, var(--brand-danger, #ff453a) 28%, transparent);
  color: #c42822;
}

.fltt-slip__cols {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.fltt-slip__col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  padding: 12px 10px;
  border-radius: 16px;
  background: color-mix(in srgb, var(--bg-card, #fff) 72%, #f3f7fb);
  border: 1px solid color-mix(in srgb, var(--fltt-accent) 10%, transparent);
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.fltt-slip__col--up {
  border-color: color-mix(in srgb, var(--brand-success, #32d74b) 35%, transparent);
  background: color-mix(in srgb, var(--brand-success, #32d74b) 8%, var(--bg-card, #fff));
}

.fltt-slip__col--down {
  border-color: color-mix(in srgb, var(--brand-danger, #ff453a) 30%, transparent);
  background: color-mix(in srgb, var(--brand-danger, #ff453a) 8%, var(--bg-card, #fff));
}

.fltt-slip__icon {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
}

.fltt-slip__icon--classement {
  color: var(--fltt-forest);
  background: color-mix(in srgb, var(--fltt-forest) 14%, transparent);
}

.fltt-slip__icon--points {
  color: var(--fltt-accent);
  background: color-mix(in srgb, var(--fltt-accent) 14%, transparent);
}

.fltt-slip__icon--national {
  color: color-mix(in srgb, var(--brand-warning, #ff9f0a) 80%, #c2410c);
  background: color-mix(in srgb, var(--brand-warning, #ff9f0a) 16%, transparent);
}

.fltt-slip__icon--brand {
  color: var(--fltt-accent);
  background: color-mix(in srgb, var(--fltt-accent) 14%, transparent);
}

.fltt-slip__label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-secondary, #6b7280);
}

.fltt-slip__figure {
  font-variant-numeric: tabular-nums;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: var(--text-color, #111);
}

.fltt-slip__move {
  font-variant-numeric: tabular-nums;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.01em;
}

.fltt-slip__move--quiet {
  color: var(--text-secondary, #9ca3af);
  font-weight: 600;
}

.fltt-slip__move--up {
  color: #0f7a32;
}

.fltt-slip__move--down {
  color: #c42822;
}

.fltt-slip__estimate {
  font-size: 10px;
  font-weight: 650;
  color: var(--text-secondary, #9ca3af);
}

.fltt-slip__stamp {
  align-self: flex-end;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--fltt-forest);
}

.fltt-slip__notify {
  align-self: flex-start;
  border: 1px solid var(--fltt-accent);
  background: transparent;
  color: var(--fltt-accent);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.fltt-slip__notify:disabled {
  opacity: 0.6;
  cursor: default;
}

.fltt-slip__notify:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.fltt-slip__history {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 6px;
  border-top: 1px solid color-mix(in srgb, var(--fltt-accent) 12%, transparent);
}

.fltt-slip__history-title {
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-secondary, #6b7280);
}

.fltt-slip__history-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 200px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.fltt-slip__history-row {
  display: grid;
  grid-template-columns: minmax(72px, 1.1fr) 0.7fr 1fr 1fr;
  gap: 6px;
  align-items: baseline;
  font-variant-numeric: tabular-nums;
  font-size: 12px;
  color: var(--text-color, #111);
  padding: 8px 10px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--fltt-accent) 5%, transparent);
}

.fltt-slip__history-week {
  font-weight: 650;
  color: var(--text-secondary, #6b7280);
}

.fltt-slip__history-metric {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  min-width: 0;
  font-weight: 650;
}

.fltt-slip__history-delta {
  font-style: normal;
  font-size: 11px;
  font-weight: 750;
}

.fltt-slip__history-delta--up {
  color: #0f7a32;
}

.fltt-slip__history-delta--down {
  color: #c42822;
}

.fltt-chart {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 2px;
}

.fltt-chart__head {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.fltt-chart__title {
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary, #6b7280);
}

.fltt-chart__subtitle {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-color, #111);
  letter-spacing: -0.01em;
}

.fltt-chart__canvas {
  width: 100%;
  min-height: 180px;
  margin-inline: -2px;
}

.fltt-chart__tooltip {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--bg-card, #fff);
  border: 1px solid color-mix(in srgb, var(--fltt-accent, #0877bc) 18%, var(--border-color, rgba(0, 0, 0, 0.08)));
  box-shadow: 0 10px 24px rgba(15, 61, 46, 0.12);
  font-size: 12px;
  color: var(--text-color, #111);
  min-width: 140px;
}

.fltt-chart__tooltip-week {
  font-weight: 700;
  letter-spacing: -0.01em;
}

.fltt-chart__tooltip-row {
  display: grid;
  grid-template-columns: 10px 1fr auto;
  gap: 8px;
  align-items: center;
  font-variant-numeric: tabular-nums;
}

.fltt-chart__tooltip-row strong {
  font-weight: 750;
}

.fltt-chart__swatch {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.fltt-chart__swatch--points {
  background: var(--fltt-accent, #0877bc);
}

.fltt-chart__swatch--place {
  background: var(--fltt-forest, #1f6b4a);
}

.dark-mode .fltt-slip {
  --fltt-ink: #d1fae5;
  --fltt-accent: #5ec8f5;
  --fltt-accent-2: #5eead4;
  --fltt-forest: #6ee7a0;
  background:
    radial-gradient(120% 80% at 100% 0%, color-mix(in srgb, var(--fltt-accent-2) 18%, transparent), transparent 55%),
    radial-gradient(90% 70% at 0% 0%, color-mix(in srgb, var(--fltt-accent) 20%, transparent), transparent 50%),
    var(--bg-card, #152033);
  border-color: color-mix(in srgb, var(--fltt-accent) 34%, rgba(255, 255, 255, 0.12));
}

.dark-mode .fltt-slip__kicker,
.dark-mode .fltt-slip__week,
.dark-mode .fltt-slip__chip-label,
.dark-mode .fltt-slip__chip-prev,
.dark-mode .fltt-slip__label,
.dark-mode .fltt-slip__move--quiet,
.dark-mode .fltt-slip__estimate,
.dark-mode .fltt-slip__history-title,
.dark-mode .fltt-slip__history-week,
.dark-mode .fltt-chart__title {
  color: #94a3b8;
}

.dark-mode .fltt-slip__title,
.dark-mode .fltt-slip__figure,
.dark-mode .fltt-slip__history-row,
.dark-mode .fltt-chart__subtitle,
.dark-mode .fltt-chart__tooltip {
  color: #f1f5f9;
}

.dark-mode .fltt-slip__col {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
}

.dark-mode .fltt-slip__col--up {
  background: color-mix(in srgb, #6ee7a0 14%, transparent);
  border-color: color-mix(in srgb, #6ee7a0 40%, transparent);
}

.dark-mode .fltt-slip__col--down {
  background: color-mix(in srgb, #ff8a82 14%, transparent);
  border-color: color-mix(in srgb, #ff8a82 40%, transparent);
}

.dark-mode .fltt-slip__chip--up {
  background: color-mix(in srgb, #6ee7a0 16%, transparent);
  border-color: color-mix(in srgb, #6ee7a0 36%, transparent);
}

.dark-mode .fltt-slip__chip--down {
  background: color-mix(in srgb, #ff8a82 16%, transparent);
  border-color: color-mix(in srgb, #ff8a82 36%, transparent);
}

.dark-mode .fltt-slip__icon--classement {
  color: #6ee7a0;
  background: color-mix(in srgb, #6ee7a0 18%, transparent);
}

.dark-mode .fltt-slip__icon--points,
.dark-mode .fltt-slip__icon--brand {
  color: #5ec8f5;
  background: color-mix(in srgb, #5ec8f5 18%, transparent);
}

.dark-mode .fltt-slip__icon--national {
  color: #fbbf24;
  background: color-mix(in srgb, #fbbf24 18%, transparent);
}

.dark-mode .fltt-slip__history-row {
  background: rgba(255, 255, 255, 0.05);
}

.dark-mode .fltt-slip__history {
  border-top-color: rgba(255, 255, 255, 0.12);
}

.dark-mode .fltt-chart__tooltip {
  background: #1e293b;
  border-color: rgba(94, 200, 245, 0.35);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.45);
  color: #f1f5f9;
}

.dark-mode .fltt-chart__swatch--points {
  background: #5ec8f5;
}

.dark-mode .fltt-chart__swatch--place {
  background: #6ee7a0;
}

.dark-mode .fltt-slip__move--up,
.dark-mode .fltt-slip__stamp,
.dark-mode .fltt-slip__chip--up,
.dark-mode .fltt-slip__history-delta--up {
  color: #86f09a;
}

.dark-mode .fltt-slip__notify {
  color: #5eead4;
  border-color: #5eead4;
}

.dark-mode .fltt-slip__move--down,
.dark-mode .fltt-slip__chip--down,
.dark-mode .fltt-slip__history-delta--down {
  color: #ff8a82;
}

/* Pingflo People trail is always dark chrome — keep slip readable even in light app theme. */
.dp-people__ranking-slip .fltt-slip {
  --fltt-ink: #d1fae5;
  --fltt-accent: #5ec8f5;
  --fltt-accent-2: #5eead4;
  --fltt-forest: #6ee7a0;
  background:
    radial-gradient(120% 80% at 100% 0%, rgba(94, 234, 212, 0.16), transparent 55%),
    radial-gradient(90% 70% at 0% 0%, rgba(94, 200, 245, 0.18), transparent 50%),
    #152033;
  border-color: rgba(94, 200, 245, 0.34);
}

.dp-people__ranking-slip .fltt-slip__kicker,
.dp-people__ranking-slip .fltt-slip__week,
.dp-people__ranking-slip .fltt-slip__chip-label,
.dp-people__ranking-slip .fltt-slip__chip-prev,
.dp-people__ranking-slip .fltt-slip__label,
.dp-people__ranking-slip .fltt-slip__move--quiet,
.dp-people__ranking-slip .fltt-slip__estimate,
.dp-people__ranking-slip .fltt-slip__history-title,
.dp-people__ranking-slip .fltt-slip__history-week,
.dp-people__ranking-slip .fltt-chart__title {
  color: #94a3b8;
}

.dp-people__ranking-slip .fltt-slip__title,
.dp-people__ranking-slip .fltt-slip__figure,
.dp-people__ranking-slip .fltt-slip__history-row,
.dp-people__ranking-slip .fltt-chart__subtitle {
  color: #f1f5f9;
}

.dp-people__ranking-slip .fltt-slip__col {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
}

.dp-people__ranking-slip .fltt-slip__history-row {
  background: rgba(255, 255, 255, 0.05);
}

.dp-people__ranking-slip .fltt-chart__tooltip {
  background: #1e293b;
  border-color: rgba(94, 200, 245, 0.35);
  color: #f1f5f9;
}

@media (max-width: 480px) {
  .fltt-slip {
    gap: 14px;
    padding: 16px 14px 14px;
    border-radius: 20px;
  }

  .fltt-slip__highlights {
    grid-template-columns: 1fr;
  }

  .fltt-slip__cols {
    gap: 8px;
  }

  .fltt-slip__col {
    align-items: center;
    text-align: center;
    padding: 12px 6px 10px;
  }

  .fltt-slip__figure {
    font-size: clamp(15px, 4.8vw, 20px);
    max-width: 100%;
    overflow-wrap: anywhere;
  }

  .fltt-slip__history-row {
    grid-template-columns: 1fr auto auto;
    gap: 6px 10px;
  }

  .fltt-slip__history-week {
    grid-column: 1 / -1;
  }

  .fltt-slip__history-metric {
    justify-content: flex-end;
  }
}

@media (max-width: 360px) {
  .fltt-slip__cols {
    gap: 6px;
  }

  .fltt-slip__figure {
    font-size: 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fltt-slip__col {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FlttRankingSlip.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,gDAAgD;EAChD,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB;;;wBAGsB;EACtB,sGAAsG;EACtG,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX;;;;;GAKC;AACH;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX;;;;GAIC;EACD,8EAA8E;EAC9E,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8EAA8E;EAC9E,gFAAgF;EAChF,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,+EAA+E;EAC/E,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iEAAiE;EACjE,yEAAyE;EACzE,uDAAuD;AACzD;;AAEA;EACE,gFAAgF;EAChF,sFAAsF;AACxF;;AAEA;EACE,+EAA+E;EAC/E,qFAAqF;AACvF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE,qEAAqE;EACrE,8EAA8E;AAChF;;AAEA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,QAAQ;EACR,qBAAqB;EACrB,kCAAkC;EAClC,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,+GAA+G;EAC/G,8CAA8C;EAC9C,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB;;;2BAGyB;EACzB,mFAAmF;AACrF;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,wDAAwD;EACxD,0DAA0D;AAC5D;;AAEA;EACE,wDAAwD;EACxD,0DAA0D;AAC5D;;AAEA;EACE,wDAAwD;EACxD,0DAA0D;AAC5D;;AAEA;EACE,wDAAwD;EACxD,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,wDAAwD;AAC1D;;AAEA;;EAEE,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,6FAA6F;AAC7F;EACE,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB;;;WAGS;EACT,sCAAsC;AACxC;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE;IACE,SAAS;IACT,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;IACnC,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;IACpC,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".fltt-slip {\n  --fltt-ink: #0f3d2e;\n  --fltt-accent: var(--brand-primary, #0877bc);\n  --fltt-accent-2: var(--brand-secondary, #30d5c8);\n  --fltt-forest: #1f6b4a;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 16px;\n  border-radius: 20px;\n  background:\n    radial-gradient(120% 80% at 100% 0%, color-mix(in srgb, var(--fltt-accent-2) 18%, transparent), transparent 55%),\n    radial-gradient(90% 70% at 0% 0%, color-mix(in srgb, var(--fltt-accent) 14%, transparent), transparent 50%),\n    var(--bg-card, #fff);\n  border: 1px solid color-mix(in srgb, var(--fltt-accent) 16%, var(--border-color, rgba(0, 0, 0, 0.08)));\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n\n.fltt-slip::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto auto 0;\n  width: 100%;\n  height: 3px;\n  background: linear-gradient(\n    90deg,\n    var(--fltt-accent) 0%,\n    var(--fltt-accent-2) 55%,\n    var(--fltt-forest) 100%\n  );\n}\n\n.fltt-slip__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.fltt-slip__brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.fltt-slip__brand-mark {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: linear-gradient(\n    145deg,\n    var(--fltt-accent) 0%,\n    color-mix(in srgb, var(--fltt-accent-2) 70%, var(--fltt-accent)) 100%\n  );\n  box-shadow: 0 6px 14px color-mix(in srgb, var(--fltt-accent) 28%, transparent);\n  flex-shrink: 0;\n}\n\n.fltt-slip__brand-text {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.fltt-slip__kicker {\n  font-size: 10px;\n  font-weight: 750;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #6b7280);\n}\n\n.fltt-slip__title {\n  font-size: 16px;\n  font-weight: 780;\n  letter-spacing: -0.02em;\n  color: var(--text-color, #111);\n  line-height: 1.15;\n}\n\n.fltt-slip__week {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary, #6b7280);\n  text-align: right;\n  line-height: 1.3;\n  max-width: 42%;\n}\n\n.fltt-slip__highlights {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 8px;\n}\n\n.fltt-slip__chip {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  border: 1px solid transparent;\n}\n\n.fltt-slip__chip-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #6b7280);\n}\n\n.fltt-slip__chip-prev {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary, #6b7280);\n}\n\n.fltt-slip__chip strong {\n  font-variant-numeric: tabular-nums;\n  font-size: 16px;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n}\n\n.fltt-slip__chip--up {\n  background: color-mix(in srgb, var(--brand-success, #32d74b) 12%, transparent);\n  border-color: color-mix(in srgb, var(--brand-success, #32d74b) 28%, transparent);\n  color: #0f7a32;\n}\n\n.fltt-slip__chip--down {\n  background: color-mix(in srgb, var(--brand-danger, #ff453a) 12%, transparent);\n  border-color: color-mix(in srgb, var(--brand-danger, #ff453a) 28%, transparent);\n  color: #c42822;\n}\n\n.fltt-slip__cols {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.fltt-slip__col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  min-width: 0;\n  padding: 12px 10px;\n  border-radius: 16px;\n  background: color-mix(in srgb, var(--bg-card, #fff) 72%, #f3f7fb);\n  border: 1px solid color-mix(in srgb, var(--fltt-accent) 10%, transparent);\n  transition: transform 0.2s ease, border-color 0.2s ease;\n}\n\n.fltt-slip__col--up {\n  border-color: color-mix(in srgb, var(--brand-success, #32d74b) 35%, transparent);\n  background: color-mix(in srgb, var(--brand-success, #32d74b) 8%, var(--bg-card, #fff));\n}\n\n.fltt-slip__col--down {\n  border-color: color-mix(in srgb, var(--brand-danger, #ff453a) 30%, transparent);\n  background: color-mix(in srgb, var(--brand-danger, #ff453a) 8%, var(--bg-card, #fff));\n}\n\n.fltt-slip__icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 2px;\n}\n\n.fltt-slip__icon--classement {\n  color: var(--fltt-forest);\n  background: color-mix(in srgb, var(--fltt-forest) 14%, transparent);\n}\n\n.fltt-slip__icon--points {\n  color: var(--fltt-accent);\n  background: color-mix(in srgb, var(--fltt-accent) 14%, transparent);\n}\n\n.fltt-slip__icon--national {\n  color: color-mix(in srgb, var(--brand-warning, #ff9f0a) 80%, #c2410c);\n  background: color-mix(in srgb, var(--brand-warning, #ff9f0a) 16%, transparent);\n}\n\n.fltt-slip__icon--brand {\n  color: var(--fltt-accent);\n  background: color-mix(in srgb, var(--fltt-accent) 14%, transparent);\n}\n\n.fltt-slip__label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #6b7280);\n}\n\n.fltt-slip__figure {\n  font-variant-numeric: tabular-nums;\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n  color: var(--text-color, #111);\n}\n\n.fltt-slip__move {\n  font-variant-numeric: tabular-nums;\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: 0.01em;\n}\n\n.fltt-slip__move--quiet {\n  color: var(--text-secondary, #9ca3af);\n  font-weight: 600;\n}\n\n.fltt-slip__move--up {\n  color: #0f7a32;\n}\n\n.fltt-slip__move--down {\n  color: #c42822;\n}\n\n.fltt-slip__estimate {\n  font-size: 10px;\n  font-weight: 650;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.fltt-slip__stamp {\n  align-self: flex-end;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--fltt-forest);\n}\n\n.fltt-slip__notify {\n  align-self: flex-start;\n  border: 1px solid var(--fltt-accent);\n  background: transparent;\n  color: var(--fltt-accent);\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.fltt-slip__notify:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.fltt-slip__notify:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.fltt-slip__history {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-top: 6px;\n  border-top: 1px solid color-mix(in srgb, var(--fltt-accent) 12%, transparent);\n}\n\n.fltt-slip__history-title {\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #6b7280);\n}\n\n.fltt-slip__history-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 200px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.fltt-slip__history-row {\n  display: grid;\n  grid-template-columns: minmax(72px, 1.1fr) 0.7fr 1fr 1fr;\n  gap: 6px;\n  align-items: baseline;\n  font-variant-numeric: tabular-nums;\n  font-size: 12px;\n  color: var(--text-color, #111);\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--fltt-accent) 5%, transparent);\n}\n\n.fltt-slip__history-week {\n  font-weight: 650;\n  color: var(--text-secondary, #6b7280);\n}\n\n.fltt-slip__history-metric {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 4px;\n  min-width: 0;\n  font-weight: 650;\n}\n\n.fltt-slip__history-delta {\n  font-style: normal;\n  font-size: 11px;\n  font-weight: 750;\n}\n\n.fltt-slip__history-delta--up {\n  color: #0f7a32;\n}\n\n.fltt-slip__history-delta--down {\n  color: #c42822;\n}\n\n.fltt-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 2px;\n}\n\n.fltt-chart__head {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.fltt-chart__title {\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #6b7280);\n}\n\n.fltt-chart__subtitle {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-color, #111);\n  letter-spacing: -0.01em;\n}\n\n.fltt-chart__canvas {\n  width: 100%;\n  min-height: 180px;\n  margin-inline: -2px;\n}\n\n.fltt-chart__tooltip {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: var(--bg-card, #fff);\n  border: 1px solid color-mix(in srgb, var(--fltt-accent, #0877bc) 18%, var(--border-color, rgba(0, 0, 0, 0.08)));\n  box-shadow: 0 10px 24px rgba(15, 61, 46, 0.12);\n  font-size: 12px;\n  color: var(--text-color, #111);\n  min-width: 140px;\n}\n\n.fltt-chart__tooltip-week {\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.fltt-chart__tooltip-row {\n  display: grid;\n  grid-template-columns: 10px 1fr auto;\n  gap: 8px;\n  align-items: center;\n  font-variant-numeric: tabular-nums;\n}\n\n.fltt-chart__tooltip-row strong {\n  font-weight: 750;\n}\n\n.fltt-chart__swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.fltt-chart__swatch--points {\n  background: var(--fltt-accent, #0877bc);\n}\n\n.fltt-chart__swatch--place {\n  background: var(--fltt-forest, #1f6b4a);\n}\n\n.dark-mode .fltt-slip {\n  --fltt-ink: #d1fae5;\n  --fltt-accent: #5ec8f5;\n  --fltt-accent-2: #5eead4;\n  --fltt-forest: #6ee7a0;\n  background:\n    radial-gradient(120% 80% at 100% 0%, color-mix(in srgb, var(--fltt-accent-2) 18%, transparent), transparent 55%),\n    radial-gradient(90% 70% at 0% 0%, color-mix(in srgb, var(--fltt-accent) 20%, transparent), transparent 50%),\n    var(--bg-card, #152033);\n  border-color: color-mix(in srgb, var(--fltt-accent) 34%, rgba(255, 255, 255, 0.12));\n}\n\n.dark-mode .fltt-slip__kicker,\n.dark-mode .fltt-slip__week,\n.dark-mode .fltt-slip__chip-label,\n.dark-mode .fltt-slip__chip-prev,\n.dark-mode .fltt-slip__label,\n.dark-mode .fltt-slip__move--quiet,\n.dark-mode .fltt-slip__estimate,\n.dark-mode .fltt-slip__history-title,\n.dark-mode .fltt-slip__history-week,\n.dark-mode .fltt-chart__title {\n  color: #94a3b8;\n}\n\n.dark-mode .fltt-slip__title,\n.dark-mode .fltt-slip__figure,\n.dark-mode .fltt-slip__history-row,\n.dark-mode .fltt-chart__subtitle,\n.dark-mode .fltt-chart__tooltip {\n  color: #f1f5f9;\n}\n\n.dark-mode .fltt-slip__col {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n.dark-mode .fltt-slip__col--up {\n  background: color-mix(in srgb, #6ee7a0 14%, transparent);\n  border-color: color-mix(in srgb, #6ee7a0 40%, transparent);\n}\n\n.dark-mode .fltt-slip__col--down {\n  background: color-mix(in srgb, #ff8a82 14%, transparent);\n  border-color: color-mix(in srgb, #ff8a82 40%, transparent);\n}\n\n.dark-mode .fltt-slip__chip--up {\n  background: color-mix(in srgb, #6ee7a0 16%, transparent);\n  border-color: color-mix(in srgb, #6ee7a0 36%, transparent);\n}\n\n.dark-mode .fltt-slip__chip--down {\n  background: color-mix(in srgb, #ff8a82 16%, transparent);\n  border-color: color-mix(in srgb, #ff8a82 36%, transparent);\n}\n\n.dark-mode .fltt-slip__icon--classement {\n  color: #6ee7a0;\n  background: color-mix(in srgb, #6ee7a0 18%, transparent);\n}\n\n.dark-mode .fltt-slip__icon--points,\n.dark-mode .fltt-slip__icon--brand {\n  color: #5ec8f5;\n  background: color-mix(in srgb, #5ec8f5 18%, transparent);\n}\n\n.dark-mode .fltt-slip__icon--national {\n  color: #fbbf24;\n  background: color-mix(in srgb, #fbbf24 18%, transparent);\n}\n\n.dark-mode .fltt-slip__history-row {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.dark-mode .fltt-slip__history {\n  border-top-color: rgba(255, 255, 255, 0.12);\n}\n\n.dark-mode .fltt-chart__tooltip {\n  background: #1e293b;\n  border-color: rgba(94, 200, 245, 0.35);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.45);\n  color: #f1f5f9;\n}\n\n.dark-mode .fltt-chart__swatch--points {\n  background: #5ec8f5;\n}\n\n.dark-mode .fltt-chart__swatch--place {\n  background: #6ee7a0;\n}\n\n.dark-mode .fltt-slip__move--up,\n.dark-mode .fltt-slip__stamp,\n.dark-mode .fltt-slip__chip--up,\n.dark-mode .fltt-slip__history-delta--up {\n  color: #86f09a;\n}\n\n.dark-mode .fltt-slip__notify {\n  color: #5eead4;\n  border-color: #5eead4;\n}\n\n.dark-mode .fltt-slip__move--down,\n.dark-mode .fltt-slip__chip--down,\n.dark-mode .fltt-slip__history-delta--down {\n  color: #ff8a82;\n}\n\n/* Pingflo People trail is always dark chrome — keep slip readable even in light app theme. */\n.dp-people__ranking-slip .fltt-slip {\n  --fltt-ink: #d1fae5;\n  --fltt-accent: #5ec8f5;\n  --fltt-accent-2: #5eead4;\n  --fltt-forest: #6ee7a0;\n  background:\n    radial-gradient(120% 80% at 100% 0%, rgba(94, 234, 212, 0.16), transparent 55%),\n    radial-gradient(90% 70% at 0% 0%, rgba(94, 200, 245, 0.18), transparent 50%),\n    #152033;\n  border-color: rgba(94, 200, 245, 0.34);\n}\n\n.dp-people__ranking-slip .fltt-slip__kicker,\n.dp-people__ranking-slip .fltt-slip__week,\n.dp-people__ranking-slip .fltt-slip__chip-label,\n.dp-people__ranking-slip .fltt-slip__chip-prev,\n.dp-people__ranking-slip .fltt-slip__label,\n.dp-people__ranking-slip .fltt-slip__move--quiet,\n.dp-people__ranking-slip .fltt-slip__estimate,\n.dp-people__ranking-slip .fltt-slip__history-title,\n.dp-people__ranking-slip .fltt-slip__history-week,\n.dp-people__ranking-slip .fltt-chart__title {\n  color: #94a3b8;\n}\n\n.dp-people__ranking-slip .fltt-slip__title,\n.dp-people__ranking-slip .fltt-slip__figure,\n.dp-people__ranking-slip .fltt-slip__history-row,\n.dp-people__ranking-slip .fltt-chart__subtitle {\n  color: #f1f5f9;\n}\n\n.dp-people__ranking-slip .fltt-slip__col {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n.dp-people__ranking-slip .fltt-slip__history-row {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.dp-people__ranking-slip .fltt-chart__tooltip {\n  background: #1e293b;\n  border-color: rgba(94, 200, 245, 0.35);\n  color: #f1f5f9;\n}\n\n@media (max-width: 480px) {\n  .fltt-slip {\n    gap: 14px;\n    padding: 16px 14px 14px;\n    border-radius: 20px;\n  }\n\n  .fltt-slip__highlights {\n    grid-template-columns: 1fr;\n  }\n\n  .fltt-slip__cols {\n    gap: 8px;\n  }\n\n  .fltt-slip__col {\n    align-items: center;\n    text-align: center;\n    padding: 12px 6px 10px;\n  }\n\n  .fltt-slip__figure {\n    font-size: clamp(15px, 4.8vw, 20px);\n    max-width: 100%;\n    overflow-wrap: anywhere;\n  }\n\n  .fltt-slip__history-row {\n    grid-template-columns: 1fr auto auto;\n    gap: 6px 10px;\n  }\n\n  .fltt-slip__history-week {\n    grid-column: 1 / -1;\n  }\n\n  .fltt-slip__history-metric {\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 360px) {\n  .fltt-slip__cols {\n    gap: 6px;\n  }\n\n  .fltt-slip__figure {\n    font-size: 14px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fltt-slip__col {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
